export default "__VITE_ASSET__BJkVR9bz__"